"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchContactProperties = fetchContactProperties;
exports.fetchContactPropertiesIfNeeded = fetchContactPropertiesIfNeeded;
exports.createContactProperty = createContactProperty;

var _underscore = require("underscore");

var _ContactPropertiesApiClient = _interopRequireDefault(require("lead-flows-ui/api/ContactPropertiesApiClient"));

var _ContactProperties = require("lead-flows-ui/selectors/ContactProperties");

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _ErrorUtils = require("lead-flows-ui/utils/ErrorUtils");

var _ErrorMessages = require("lead-flows-ui/constants/ErrorMessages");

var CONTACT_INFORMATION_GROUP = 'contactinformation';

function requestContactProperties() {
  return {
    type: _ActionTypes.REQUEST_CONTACT_PROPERTIES
  };
}

function receiveContactProperties(_ref) {
  var properties = _ref.properties,
      groups = _ref.groups;
  return {
    type: _ActionTypes.RECEIVE_CONTACT_PROPERTIES,
    properties: properties,
    groups: groups
  };
}

function handleContactPropertiesFetchError() {
  return {
    type: _ActionTypes.HANDLE_CONTACT_PROPERTIES_FETCH_ERROR
  };
}

function requestContactPropertyCreation() {
  return {
    type: _ActionTypes.REQUEST_CONTACT_PROPERTY_CREATION
  };
}

function handlePropertyCreationSuccess(property) {
  return {
    type: _ActionTypes.HANDLE_PROPERTY_CREATION_SUCCESS,
    property: property
  };
}

function handlePropertyCreationError(message) {
  var descreptiveMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    type: _ActionTypes.HANDLE_PROPERTY_CREATION_ERROR,
    message: message,
    descreptiveMessage: descreptiveMessage
  };
}

function fetchContactProperties() {
  return function (dispatch) {
    dispatch(requestContactProperties());

    _ContactPropertiesApiClient.default.fetchProperties().then(function (groups) {
      var properties = (0, _underscore.flatten)((groups || []).map(function (el) {
        return el.properties;
      }));
      dispatch(receiveContactProperties({
        properties: properties,
        groups: groups
      }));
    }, function () {
      return dispatch(handleContactPropertiesFetchError());
    }).done();
  };
}

function fetchContactPropertiesIfNeeded() {
  return function (dispatch, getState) {
    var requestState = (0, _ContactProperties.getRequestState)(getState());

    if (!requestState.shouldBeRequested()) {
      return;
    }

    dispatch(fetchContactProperties());
  };
}

function createContactProperty(_ref2) {
  var name = _ref2.name,
      label = _ref2.label,
      fieldType = _ref2.fieldType,
      type = _ref2.type,
      options = _ref2.options,
      groupName = _ref2.groupName,
      description = _ref2.description;
  return function (dispatch, getState) {
    var properties = (0, _ContactProperties.getProperties)(getState());
    var lastProperty = (0, _underscore.chain)(properties).filter(function (property) {
      return property.groupName === CONTACT_INFORMATION_GROUP;
    }).sortBy(function (property) {
      return property.displayOrder;
    }).last().value();
    var newDisplayOrder = lastProperty ? lastProperty.displayOrder + 1 : 0;
    var newProperty = {
      name: name,
      label: label,
      options: options,
      description: description,
      groupName: groupName || CONTACT_INFORMATION_GROUP,
      type: type || 'string',
      fieldType: fieldType || 'text',
      formField: true,
      displayOrder: newDisplayOrder
    };
    dispatch(requestContactPropertyCreation());

    _ContactPropertiesApiClient.default.createProperty(newProperty).then(function (property) {
      return dispatch(handlePropertyCreationSuccess(property));
    }, function (error) {
      var response = (0, _ErrorUtils.parseResponseJson)(error.xhr.response);
      var propertyLimitReached = response.errorType && response.errorType === 'LimitExceededException';
      var descreptiveMessage = response.message;
      var message = propertyLimitReached ? _ErrorMessages.CONTACT_PROPERTIES.PROPERTY_LIMIT_REACHED : _ErrorMessages.CONTACT_PROPERTIES.UNKNOWN_ERROR;
      dispatch(handlePropertyCreationError(message, descreptiveMessage));
    }).done();
  };
}